<script setup lang="ts">
const group = useFitTextGroup()
provide(FitTextGroupKey, group)
</script>

<template>
  <slot :font-size="group.minSize.value" />
</template>
